import { Heading } from '@components/gassan-ui/Typography/Heading'
import { CleanButton, Icon } from '@gassan-ui'
import { cn } from '@lib/cn'
import { FC } from 'react'

type Props = {
  onClickClose: () => void
}

export const HeaderSearchHeader: FC<Props> = ({ onClickClose, children }) => {
  return (
    <div
      className={cn(
        'absolute flex w-full justify-between bg-pampas',
        'h-12 border-b border-tabaccoLight',
        'top-0 z-[2]',
        'lg:hidden',
      )}
    >
      <div
        className={cn(
          'mx-auto flex w-[calc(100%-16px)]',
          'items-center justify-between text-center',
        )}
      >
        <CleanButton onClick={onClickClose}>
          <Icon icon="cross" />
        </CleanButton>
        <Heading variant="h3" as="h3" className="mb-0">
          {children}
        </Heading>
        <div className="h-10 md:p-16" />
      </div>
    </div>
  )
}
